export const columns = [
    { field: 'id', headerName: 'ID', flex: 1, minWidth: 90, hide: true },
    { field: 'category', headerName: 'Categoría', flex: 1, minWidth: 100 },
    { field: 'equipo_local', headerName: 'Equipo Local', flex: 1, minWidth: 200 },
    { field: 'equipo_visitante', headerName: 'Equipo Visitante', flex: 1, minWidth: 200 },
    { field: 'sets_local', headerName: 'Sets Local', type: 'number', flex: 1, minWidth: 100 },
    { field: 'sets_visitante', headerName: 'Sets Visitante', type: 'number', flex: 1, minWidth: 110 },
    { field: 'fecha', headerName: 'Fecha', flex: 1, minWidth: 110 },
    { field: 'hora', headerName: 'Hora', flex: 1, minWidth: 80 },
    { field: 'cancha', headerName: 'Cancha', flex: 1, minWidth: 150 }
  ];
  